import { ref } from 'vue'
import { api } from '../api/http'
import { useAuthStore } from '../stores/auth'
import { useWalletStore } from '../stores/wallet'

/** Coins to explain in the toast. 0 hides it. */
export const interruptNoticeCoins = ref(0)

let inflight: Promise<void> | null = null
let claimed = false
let acked = false

/**
 * Loads an unread deploy reward, updates the coin chip, and arms the toast.
 * A miss stays unclaimed so a later reconnect can try again.
 * Pass `force` when a duel was just cut, so a notice already shown in this
 * visit does not hide a new one.
 */
export function pullInterruptNotice(force = false): Promise<void> {
  if (!force && claimed) return Promise.resolve()
  if (inflight) return inflight
  inflight = loadNotice(force).finally(() => {
    inflight = null
  })
  return inflight
}

async function loadNotice(force: boolean): Promise<void> {
  const token = useAuthStore().token
  if (!token) return
  try {
    const body = await api<{ coins: number; balance: number }>(
      '/account/interrupt-notice',
      { token },
    )
    if (!body.coins) {
      if (force) claimed = false
      return
    }
    claimed = true
    acked = false
    useWalletStore().setCoins(body.balance)
    interruptNoticeCoins.value = body.coins
  } catch {
    /* A later visit, or the reconnect on the duel page, can try again. */
  }
}

/** Marks the notice read. Safe to call more than once. */
export async function ackInterruptNotice(): Promise<void> {
  if (acked) return
  acked = true
  const token = useAuthStore().token
  if (!token) return
  try {
    await api('/account/interrupt-notice/ack', { method: 'POST', token })
  } catch {
    acked = false
  }
}
